import React from "react";
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from "@heroicons/react/24/outline";

interface SortIconProps {
  field: string;
  currentField: string;
  currentOrder: "asc" | "desc" | null;
}

export const SortIcon: React.FC<SortIconProps> = ({
  field,
  currentField,
  currentOrder,
}) => {
  if (currentField !== field || !currentOrder) {
    return <ChevronUpIcon className="w-3 h-3 text-gray-300" />;
  }

  return currentOrder === "asc" ? (
    <ChevronUpIcon className="w-3 h-3 text-blue-600" />
  ) : (
    <ChevronDownIcon className="w-3 h-3 text-blue-600" />
  );
};
